<script setup lang="ts">

type Props = {
    category: number,
    currentCategory: number
}

defineProps<Props>();
const emit = defineEmits( [ 'on-category-selected' ] );

</script>

<template>
    <button class="
        flex-1 flex flex-col hover:brightness-110 cursor-pointer 
        transition-all duration-300 text-base tracking-wider 
        p-1 rounded-lg
        "
        :class="{ 'ring ring-amber-300': currentCategory == category }"
        @click="() => emit( 'on-category-selected', category )">
        <div class="flex flex-col items-center gap-1 p-3 bg-[#0CACF2] font-semibold uppercase rounded-t">
            <span class="rounded-full ring-1 ring-cyan-900 text-cyan-900 text-xs text-center px-2">
                <slot name="title" />
            </span>
            <span>
                Category {{ category }}
            </span>
        </div>
        <div class="
            grow text-sm px-3 py-6 text-center rounded-b mt-0.5
            bg-indigo-600 bg-gradient-to-b from-[#0CACF2]/70 via-indigo-600 to-indigo-500">
            <slot />
        </div>
    </button>
</template>